<template>
  <div class="header_div">
    <!-- 固定头部-->
    <div class="ding">
      <div class="headertop">
        <!-- 左侧公司-->
        <img :src="info.company.logo" />
        <h3 class="conpanyname left">{{info.company.name}}<span class="slogan" v-if="info.company.slogan!='0'">{{info.company.slogan}}</span></h3>

        <!-- 右侧个人-->
        <div class="right">
          <el-dropdown class="center" style="width: 100%;">
            <span class="el-dropdown-link right">
              <div class="headimg left">
                <el-avatar :src="info.img"></el-avatar>
              </div>
              <div class="right" style="cursor: pointer;margin-top: 0.625rem;">
                  <i   class="el-icon-setting"></i>
              </div>
              <p class="headmsg right" style="cursor: pointer;">
                {{info.rale_name}}<br />
                <span v-if="info.type==0">普通用户</span>
                <span v-if="info.type==1">部门管理员</span>
                <span v-if="info.type==2">企业管理员</span>
              </p>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="info.company.name=='北京睿知而行科技有限公司'"><span @click="moderator_click()"> 版主反馈</span></el-dropdown-item>
              <el-dropdown-item v-if="info.company.name=='北京睿知而行科技有限公司'"><router-link to="/moderator">反馈状态</router-link></el-dropdown-item>
              <el-dropdown-item><router-link to="/personal"><i class="el-icon-user"></i> 个人中心</router-link></el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/minenode"><i class="el-icon-notebook-2"></i> 我的笔记</router-link>
              </el-dropdown-item>
              <el-dropdown-item ><router-link to="/collect"><i class="el-icon-star-off"></i> 我的收藏</router-link></el-dropdown-item>
              <el-dropdown-item>
                <span @click="logout()"><i class="el-icon-switch-button"></i> 退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <br />
          <el-button type="primary"  size="mini" round @click="goTo('/cindex?choice=chome')" v-if="info.type>0">我要管理 <span style="font-size: 0.05rem;">To manage</span></el-button>
          <el-button v-show="traincount_status_show" type="danger" size="mini" round @click="goTo('/tasklist')">我的任务My Task</el-button>
          <el-button v-show="traincount_status_showt" type="success" size="mini" round @click="goTo('/tasklist')">我的任务My Task</el-button>
        </div>

      </div>


      <!-- 导航栏-->

      <div class="headernav" >
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          background-color="#336397" text-color="#fff" active-text-color="#fff" menu-trigger="click"
          router :unique-opened="true" >
          <div v-for="(item,i) in get_lists" :key="i" style="display: inline;">
            <el-menu-item v-if="item.childs == 0"  :index="item.index"  style="display: inline; width: 100%;">
            <span v-if="item.name=='一对一技术咨询'&& new_data <'2023-6-26 00:00'" style="">
              {{item.name}}
              <!-- <span style="position: relative;top:-1.1875rem;left: 3.75rem;"> -->
                <span style="position: relative;top:-1.1875rem;">
                <!-- <img src="../../../assets/new_time.png" style="width: 1.875rem;z-index: 999;" /> -->
                <span class="new_time">
                  限时免费
                </span>
              </span>

              <!-- <span style="color: red;margin-left: 0.625rem;">(限时免费)</span> -->
            </span>
            <span v-else >{{item.name}}</span>
            </el-menu-item>
            <el-submenu v-if="item.childs == 1" :index="item.index"  style="display: inline;">
              <template slot="title" style="display: inline; ">
                <span style="margin-right: 0.8125rem;">{{item.name}}</span>
            </template>
              <el-menu-item v-for="(items,is) in item.child" :key="is" :index="items.index">
                <span>{{items.name}}</span>
              </el-menu-item>
            </el-submenu>
           </div>
          </span>
        </el-menu>
      </div>
    </div>
    <!-- 占位-->
    <div class="zhan">
      <el-dialog title=需求/反馈 :visible.sync="problem.show">
        <el-dropdown  style="margin-bottom: 10px;">
          <span class="el-dropdown-link1111">
            {{problem.dropdown}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" @click="handleClick">
            <el-dropdown-item @click.native="handleClick('课程需求')">课程需求</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('系统问题')">系统问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('视频问题')">视频问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('文档问题')">文档问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('任务问题')">任务问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('其他')">其他</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-input  type="textarea" :rows="3" v-model="problem.input" placeholder="请详细描述"></el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="feedback()">确 定</el-button>
            <el-button @click="problem.show = false " >取 消</el-button>
          </div>
      </el-dialog>

      <el-dialog title='反馈入口' :visible.sync="moderator.dialog_show" top="40vh" >
        <el-select v-model="moderator.value" placeholder="请选择">
            <el-option
              v-for="item in moderator.type_list"
              :key="item.num"
              :label="item.name"
              :value="item.num">
            </el-option>
          </el-select>
        <el-input  style="margin-top: 1.25rem;" type="textarea" autosize v-model="moderator.input" placeholder="如：[Z220132]最新药品召回管理办法解读和GMP要求解析应归为进阶课"></el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="moderatorback()">确 定</el-button>
            <el-button @click="moderator.dialog_show = false " >取 消</el-button>
          </div>
      </el-dialog>
      <el-dialog title='咨询入口' :visible.sync="consult.show">
        <el-select v-model="consult.value" placeholder="请选择">
            <el-option
              v-for="item in moderator.type_list"
              :key="item.num"
              :label="item.name"
              :value="item.num">
            </el-option>
          </el-select>
        <el-input  style="margin-top: 1.25rem;" type="textarea" autosize v-model="consult.input" placeholder="请输入您的问题"></el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="consultback()">确 定</el-button>
            <el-button @click="consult.show = false " >取 消</el-button>
          </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialog_height:document.documentElement.clientHeight * 0.5+'px',
        consult:{
          show:false,
          input:'',
          value:'',
          type_list:[]
        },
        moderator: {
          dialog_show:false,
          type_list:[],
          input:'',
          value:'',
          show:false
        },
        new_data:'',
        problem:{
          input:'',
          show:false,
          dropdown :'需求/反馈类型',
        },
        info:this.$store.state.info,
        activeIndex: '1',
        get_lists:[],
        traincount_status:'',
        traincount_status_show:'',
        traincount_status_showt:'',
      };
    },
    mounted:function(){
      this.get_list_type()
      this.get_train_count()
      this.new_data_click()
      this.get_type()
    },
    methods: {
      get_type(){
        let _this=this
        _this.axios.get('/v2/user/feedback_type').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.moderator.type_list=res.data.data
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      consultback(){
        let _this=this
        let data={
         type:_this.consult.value,
         content:_this.consult.input,
        }
        _this.axios.post('/v2/user/save_gxp_msg', {
          data: data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
               _this.$message.success(res.data.msg)
               _this.consult.show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
        console.log('选择'+_this.consult.value,'填空'+_this.consult.input)
      },
      get_list_type(){
        let _this=this
          _this.get_lists=[
            {index:"home",name:"首页",ename:'',childs:0},
            {index:"tasklist",name:"任务",ename:'',child:[],childs:0},
            {index:"3",name:"药知",ename:'',child:[
              {index:"opencourses?type=0",name:"课程",},
              {index:"livebroadcast",name:"直播",},
              {index:"question",name:"精彩问答",},
            ],childs:1 },
            {index:"4",name:"内部",ename:'',child:[
              {index:"opencourses?type=1",name:"视频",},
              {index:"filetow?num=0",name:"文档",},
            ],childs:1 },
            {index:"8",name:"法规",ename:'',child:[
              {index:"statute",name:"在线查看",},
              {index:"statute_map?num=",name:"地图链接",},
              {index:"Official_account_list",name:"最新",},
            ],childs:1 },
            {index:"6",name:"测评",ename:'',childs:0},
            {index:"7",name:"说明/帮助",ename:'',child:[
              {index:'#rzex',name:'睿知而行官网'},
              {index:'#help',name:'使用说明'},
              {index:'#problem',name:'需求/反馈'},
              // {index:'#question',name:'提问'},
              {index:"customizedcourses",name:"定制",},
              {index:'client_download',name:'客户端下载'},
            ],childs:1},
            {index:"consult?per_page=10&current_page=1",name:"一对一技术咨询",ename:'',child:[],childs:0},
          ]
      },
      moderatorback(){
        let _this=this
        let data={
          type:_this.moderator.value,
          content:_this.moderator.input
        }
        _this.axios.post('/v2/user/feedback_up', {
          data: data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.moderator.dialog_show=false
              _this.moderator.value=''
              _this.moderator.input=''
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },
      new_data_click(){
        let yy = new Date().getFullYear();
        　　let mm = new Date().getMonth()+1;
        　　let dd = new Date().getDate();
        　　let hh = new Date().getHours();
        　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            if (mm < 10) mm = "0" + mm;
            if (dd < 10) dd = "0" + dd;
            if (hh < 10) hh = "0" + hh;
            if (mf < 10) mf = "0" + mf;
        　　 this.new_data = yy+'-'+mm+'-'+dd+' '+hh+':'+mf;
      },
      handleClick(type){
        this.problem.dropdown=type
      },

      feedback(){
        let _this=this
        var data={
          'type':_this.problem.dropdown,
          'content':_this.problem.input
        }
        if(data.type=='需求/反馈类型'){
          _this.$message.error('请选择需求/反馈类型')
          return false
        }
        if(data.content==''){
          _this.$message.error('描述内容不能为空')
          return false
        }
        _this.axios.post('/v2/user/feedback_save', {
          data: data //注意post请求发送参数的方式和get请求方式是有区别的
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
             _this.$message.success(res.data.msg)
             _this.problem.show=false
             _this.problem.input=''
             _this.problem.dropdown='需求/反馈类型'
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        })
      },
      problem_cilck(){
        this.problem.show=true
      },
      get_feedback_type(){
        let _this = this;
          _this.axios
        .get("/v2/user/feedback_type")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {

            }
          }
        })
      },
      get_train_count(){
        let _this = this;
          _this.axios
        .get("/v2/user/get_train_count",
        {params:{limit:'1'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.traincount=res.data.data;
              if(_this.traincount.status ){
                _this.traincount_status_show = false
                _this.traincount_status_showt = true
              }else{
                 _this.traincount_status_showt = false
                _this.traincount_status_show = true
              }
            }
          }
        })
      },

      moderator_click(){
        let _this=this
        _this.moderator.dialog_show=true
      },
      handleSelect(key, keyPath) {
        var s=window.location.href;
        s=s.replace(/keyPath[1]/g, ''); // \:转义符
        // if(keyPath[0]==5 && keyPath[1]==""){
        //   this.goPage('https://appy50vdxnm5900.h5.xiaoeknow.com/')
        // }
        if(keyPath[0]==6){
          this.check_power(s)
        }
        if(keyPath[0]==7 && keyPath[1]=='#rzex'){
         this.goPage('https://ruizhierxing.com')
         window.location.href=s
        }
        if(keyPath[0]==7 && keyPath[1]=='#problem'){
          this.problem_cilck()
        }
        if(keyPath[0]==7 && keyPath[1]=='#help'){
         this.goPage('https://api.zhiyaozhishi.com/mind/handbook.html')
         window.location.href=s
        }
        // if(keyPath[0]=='#8' ){
        //   this.consult.show=true
        // }
      },
      // 跳转页面方法
      /* 新标签页*/
      goPage(url) {
        window.open(url, '_blank')
      },
      /* 原页面 */
      goTo(url) {
        this.$router.push(url)
      },

      check_power(s){
        let _this=this
        _this.axios.post("/v2/user/check_evaluate").then(function (res) {
          if(res.data.code=='1'){
            if(res.data.hasOwnProperty('data') && res.data.data.hasOwnProperty('href')){
              _this.goPage(res.data.data.href)
              window.location.href=s
            }
          }else{
            _this.$message.error(res.data.msg)
          }
        })
      },

      logout(){
        let _this=this
        localStorage.setItem('authorization', '')
        this.$store.commit('info_save', null)
        setTimeout(()=>{
          _this.$notify({
            title: '成功退出',
            type: 'success'
          });
          this.$router.push({
            path: '/login',
            query: {redirect: this.$route.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          });
        },1000)

      },
    },
  }
</script>

<style scoped>
   .el-dropdown-link1111 {
      cursor: pointer;
      color: #409EFF;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
>>>.el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 0 20px;
    cursor: pointer;
    -webkit-transition: border-color .3s,background-color .3s,color .3s;
    transition: border-color .3s,background-color .3s,color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline;
}
  .header_div {
    height: 150px;
    background-color: white;
    z-index: 999;
  }

  .ding {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .zhan {
    height: 150px;
  }

  .headertop {
    background-color: white;
    height: 90px;
    width: 70%;
    padding: 0 15%;
  }

   .headertop img {
      width: 6.25rem;
      height: 3.125rem;
      padding: 20px;
      float: left;
    }

  .slogan {
    padding-left: 20px;
    font-size: 15px;
  }

  .conpanyname {
    padding: 20px;
  }

  .headimg,
  .headmsg {
    margin: 5px;
  }

  .el-menu-demo {
      width: 100%;
      padding-left: 14%;
      float: left;
    }

  <<<.el-menu {
      /* margin: 0; */
      width: 100%;
      border: 0;
    }


  router-link:link {
    text-decoration: none;
    color: #606266;
    /* 指正常的未被访问过的链接*/
  }

  router-link:visited {
    text-decoration: none;
    color: #606266;
    /*指已经访问过的链接*/
  }

  router-link:hover {
    text-decoration: none;
    color: #66B1FF;
    /*指鼠标在链接*/
  }

  router-link:active {
    text-decoration: none;
    color: #66B1FF;
    /* 指正在点的链接*/
  }

  a:link {
    text-decoration: none;
    color: #606266;
    /* 指正常的未被访问过的链接*/
  }

  a:visited {
    text-decoration: none;
    color: #606266;
    /*指已经访问过的链接*/
  }

  a:hover {
    text-decoration: none;
    color: #66B1FF;
    /*指鼠标在链接*/
  }

  a:active {
    text-decoration: none;
    color: #66B1FF;
    /* 指正在点的链接*/
  }
.over{
    overflow: auto;
    padding: 0 1.25rem;
    margin-bottom: 0.625rem;
    margin-top: 0.625rem;
  }
.new_time{
      font-size: 12px;
     /* position: absolute;
      height: 19px;
      display: block; */
      line-height: 19px;
      padding: 0 8px;
      background: red;
      color: #fff;
      -webkit-border-radius: 3px;
      border-radius: 10.5px;
      width: 64px;
      text-align: center;
      overflow: hidden;
      top: -19px;
      left: -8px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/public/NavHeader.vue